<template>
  <!-- Navigation -->
  <div class="container-fluid navbar-bg px-0">
    <div class="desktop-nav-container mx-auto">
      <nav class="navbar navbar-expand-lg p-3">
        <div class="container-fluid">
          <div class="my-auto text-light mobile-nav-text">
            <router-link to="/">
              <a class="navbar-brand" href="#">
                <img src="/img/theme-park-buddy-main-logo.png" alt="Theme Park Buddy Logo showing a roller coaster outline" class="main-logo">
              </a>
            </router-link>
          </div>
          <button ref="navToggler" @click="collapsed = !collapsed" class="navbar-toggler collapsed d-flex d-lg-none flex-column justify-content-around" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="toggler-icon top-line" :class="{ close: !collapsed }"></span>
            <span class="toggler-icon middle-line"></span>
            <span class="toggler-icon bottom-line" :class="{ close: !collapsed }"></span>
          </button>
          <div class="collapse navbar-collapse text-sm-start" id="navbarNav">
            <div class="d-none d-lg-block">
              <ul class="navbar-nav align-items-end">
                <router-link to="/favourites">
                  <li class="nav-item">
                    <p class="nav-link m-auto" href="#">Favourite List</p>
                  </li>
                </router-link>
              </ul>
            </div>
            <!-- MOBILE NAV -->
            <div class="d-block d-lg-none px-0">
              <ul class="navbar-nav text-end">
                <router-link to="/favourites">
                  <li class="nav-item" @click="closeMenu">
                    <p class="nav-link m-auto" href="#">Favourite List</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavBar',

  data() {
    return {
      collapsed: true,
      closeNav: false
    }
  },
  methods: {
    closeMenu() {
      if (!this.collapsed) {
        const toggler = this.$refs.navToggler;
        if (toggler) toggler.click();
      }
    }
  }
}
</script>

